import { render, staticRenderFns } from "./GuppyChatProfileSetting.vue?vue&type=template&id=fd4cde66&"
import script from "./GuppyChatProfileSetting.vue?vue&type=script&lang=js&"
export * from "./GuppyChatProfileSetting.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatProfileSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports